import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from "../../config/config";
import { map } from 'rxjs/operators';
import { apiConstants } from "../constant/apiConstant";
import { commonFunctionService } from "../utils/commonFunctions";

@Injectable()
export class AttendanceService {

    private URL_V3 = AppSettings.API_ENDPOINT_V3;

    headers: HttpHeaders;

    constructor(private http: HttpClient, private commonFunction: commonFunctionService) {

    }

    getClassListData() {
        const headers = this.commonFunction.appendHeader();
        const schoolData = localStorage.getItem('schoolAllInfo');
        const schoolDataParsed = JSON.parse(schoolData);
        return this.http.get(this.URL_V3 + `${apiConstants.getClassListDataAttendance}/?lang=en&academicId=${schoolDataParsed.currentAcademicId}`, { headers }).pipe(map(res => res));
    }

    getClassStandardList(selectedCategory) {
        const headers = this.commonFunction.appendHeader();
        const schoolData = localStorage.getItem('schoolAllInfo');
        const schoolDataParsed = JSON.parse(schoolData);
        return this.http.get(this.URL_V3 + `${apiConstants.getClassListCategory}/?lang=en&academicId=${schoolDataParsed.currentAcademicId}&classCategoryId=${selectedCategory}`, { headers }).pipe(map(res => res));
    }

    getClassSectionData(selectedCategory, classStandardId) {
        const headers = this.commonFunction.appendHeader();
        const schoolData = localStorage.getItem('schoolAllInfo');
        const schoolDataParsed = JSON.parse(schoolData);
        return this.http.get(this.URL_V3 + `${apiConstants.getSectionListData}/?lang=en&academicId=${schoolDataParsed.currentAcademicId}&classCategoryId=${selectedCategory}&classStandardId=${classStandardId}`, { headers }).pipe(map(res => res));

    }

    getGenderList() {
        const headers = this.commonFunction.appendHeader();
        return this.http.get(this.URL_V3 + `${apiConstants.getGenderList}/?lang=en`, { headers }).pipe(map(res => res));
    }

    getStudentListData(classWingId, classCategoryId, classSectionId, gender) {
        const headers = this.commonFunction.appendHeader();
        const schoolData = localStorage.getItem('schoolAllInfo');
        const schoolDataParsed = JSON.parse(schoolData);
        return this.http.get(this.URL_V3 + `${apiConstants.getStudentListData}/?lang=en&academicId=${schoolDataParsed.currentAcademicId}&classCategoryId=${classWingId}&classStandardId=${classCategoryId}&classId=${classSectionId}&gender=${gender}`, { headers }).pipe(map(res => res));

    }

    getStatData(payload) {
        const headers = this.commonFunction.appendHeader();
        const schoolData = localStorage.getItem('schoolAllInfo');
        const schoolDataParsed = JSON.parse(schoolData);
        return this.http.get(this.URL_V3 + `${apiConstants.getStudentAttendanceStat}/?lang=en&academicId=${schoolDataParsed.currentAcademicId}&classCategoryId=${payload.classCategoryId}&classStandardId=${payload.classStandardId}&classId=${payload.classId}&gender=${payload.gender}&startDate=${payload.startDate}&endDate=${payload.endDate}&studentIdList=${payload.studentList}`, { headers }).pipe(map(res => res));
    }

    getAllClassData(payload) {
        const headers = this.commonFunction.appendHeader();
        const schoolData = localStorage.getItem('schoolAllInfo');
        const schoolDataParsed = JSON.parse(schoolData);
        return this.http.get(this.URL_V3 + `${apiConstants.getAllClassesData}/?lang=en&academicId=${schoolDataParsed.currentAcademicId}&classCategoryId=${payload.classCategoryId}&classStandardId=${payload.classStandardId}&gender=${payload.gender}&startDate=${payload.startDate}&endDate=${payload.endDate}&pageLimit=${payload.limit}&pageNumber=${payload.pageNumber}`, { headers }).pipe(map(res => res));
    }

    getStudentDataClassWise(payload) {
        const headers = this.commonFunction.appendHeader();
        const schoolData = localStorage.getItem('schoolAllInfo');
        const schoolDataParsed = JSON.parse(schoolData);
        return this.http.get(this.URL_V3 + `${apiConstants.getClassWiseData}/?lang=en&academicId=${schoolDataParsed.currentAcademicId}&classCategoryId=${payload.classCategoryId}&classStandardId=${payload.classStandardId}&classId=${payload.classId}&gender=${payload.gender}&startDate=${payload.startDate}&endDate=${payload.endDate}&studentIdList=${payload.studentList}&pageNumber=${payload.pageNumber}&pageLimit=${payload.pageLimit}`, { headers }).pipe(map(res => res));
    }

    exportReportData(body) {
        const headers = this.commonFunction.appendHeader();
        return this.http.post(this.URL_V3 + `${apiConstants.exportAttendanceReport}`, body, { headers, responseType: 'blob' as 'json' }).pipe(map(res => res));
    }
}